module.exports = __webpack_public_path__ + "img/headLogoB.2c7bd20f.png";